import React from 'react';
import styles from './AttendanceRingChart.module.css';
import { FaUserFriends } from 'react-icons/fa';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';

const AttendanceRingChart = ({
  studentPercentage = 0,
  staffPercentage = 0,
}) => {
  const width = 140;
  const center = width / 2;
  const strokeWidth = width * 0.015; // 2% of width
  const radiusStudent = width * 0.32; // 32% of width
  const radiusStaff = width * 0.24; // 24% of width
  const dotRadius = width * 0.035; // 3.5% of width

  const circumferenceStudent = 2 * Math.PI * radiusStudent;
  const circumferenceStaff = 2 * Math.PI * radiusStaff;

  const offsetStudent = circumferenceStudent * (1 - studentPercentage / 100);
  const offsetStaff = circumferenceStaff * (1 - staffPercentage / 100);

  const getCoordinatesForPercent = (percent, radius) => {
    const angle = 2 * Math.PI * (percent / 100);
    const x = center + radius * Math.cos(angle);
    const y = center + radius * Math.sin(angle);
    return { x, y };
  };

  const studentDot = getCoordinatesForPercent(studentPercentage, radiusStudent);
  const staffDot = getCoordinatesForPercent(staffPercentage, radiusStaff);

  return (
    <div className={styles.attendanceCard}>
      <div className={styles.title}>
        <HeadingAndIcon heading={'Attendance Chart'} />
      </div>
      <div className={styles.chartWrapper}>
        <svg width={width} height={width} className={styles.chart}>
          {/* Background Circles */}
          <circle
            className={styles.bgCircle}
            cx={center}
            cy={center}
            r={radiusStudent}
            strokeWidth={strokeWidth}
          />
          <circle
            className={`${styles.progress} ${styles.student}`}
            cx={center}
            cy={center}
            r={radiusStudent}
            strokeWidth={strokeWidth}
            strokeDasharray={circumferenceStudent}
            strokeDashoffset={offsetStudent}
          />
          <circle
            className={styles.bgCircle}
            cx={center}
            cy={center}
            r={radiusStaff}
            strokeWidth={strokeWidth}
          />
          <circle
            className={`${styles.progress} ${styles.staff}`}
            cx={center}
            cy={center}
            r={radiusStaff}
            strokeWidth={strokeWidth}
            strokeDasharray={circumferenceStaff}
            strokeDashoffset={offsetStaff}
          />

          {/* End Dots */}
          <circle
            cx={studentDot.x}
            cy={studentDot.y}
            r={dotRadius}
            className={styles.studentDotSVG}
          />
          <circle
            cx={staffDot.x}
            cy={staffDot.y}
            r={dotRadius}
            className={styles.staffDotSVG}
          />
        </svg>

        <div
          className={styles.iconWrapper}
          style={{
            width: width * 0.3, // 33% of the chart width
            height: width * 0.3,
            borderRadius: '50%',
          }}
        >
          <FaUserFriends className={styles.centerIcon} size={'50%'} />
        </div>
      </div>

      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <span className={`${styles.dot} ${styles.studentDot}`}></span>
          <span>Student Present - {studentPercentage}%</span>
        </div>
        <div className={styles.legendItem}>
          <span className={`${styles.dot} ${styles.staffDot}`}></span>
          <span>Staff Present - {staffPercentage}%</span>
        </div>
      </div>
    </div>
  );
};

export default AttendanceRingChart;
